// extracted by mini-css-extract-plugin
export var markdown = "_sc-0";
export var tableWrapper = "_sc-1";